import { useEffect, useState } from 'react';
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, Typography, Button, Snackbar, Alert,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FolderIcon from '@mui/icons-material/Folder';
import DashboardLayout from '../components/DashboardLayout';
import api from '../services/api';

const STATUS_COLOR = { SUBMITTED: 'info', LOCKED: 'warning', OPENED: 'success', WITHDRAWN: 'default' };

export const vendorNav = [
  { label: 'Dashboard', path: '/vendor', icon: <DashboardIcon /> },
  { label: 'Open Tenders', path: '/vendor/tenders', icon: <DescriptionIcon /> },
  { label: 'My Bids', path: '/vendor/bids', icon: <InventoryIcon /> },
  { label: 'Clarifications', icon: <QuestionAnswerIcon />, disabled: true },
  { label: 'Award Results', icon: <EmojiEventsIcon />, disabled: true },
  { label: 'Profile & Documents', path: '/vendor/profile', icon: <FolderIcon /> },
];

export default function VendorBids() {
  const [bids, setBids] = useState([]);
  const [toast, setToast] = useState('');

  const load = async () => {
    const { data } = await api.get('/bids/mine');
    setBids(data.data);
  };
  useEffect(() => { load(); }, []);

  const withdraw = async (id) => {
    if (!window.confirm('Withdraw this bid? This cannot be undone.')) return;
    try {
      await api.post(`/bids/${id}/withdraw`);
      setToast('Bid withdrawn');
      load();
    } catch (err) {
      setToast(err.response?.data?.error?.message || 'Could not withdraw bid');
    }
  };

  return (
    <DashboardLayout nav={vendorNav} title="My Bids">
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Bid Ref</TableCell><TableCell>Tender</TableCell><TableCell>Submitted</TableCell>
              <TableCell>Status</TableCell><TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bids.map((b) => (
              <TableRow key={b.id} hover>
                <TableCell>{b.reference}</TableCell>
                <TableCell>{b.tender?.title}</TableCell>
                <TableCell>{new Date(b.submittedAt).toLocaleString('en-GB')}</TableCell>
                <TableCell><Chip size="small" label={b.status} color={STATUS_COLOR[b.status]} /></TableCell>
                <TableCell align="right">
                  {b.status === 'SUBMITTED' && <Button size="small" color="error" onClick={() => withdraw(b.id)}>Withdraw</Button>}
                </TableCell>
              </TableRow>
            ))}
            {bids.length === 0 && (
              <TableRow><TableCell colSpan={5}><Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>You haven't submitted any bids yet.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <Snackbar open={!!toast} autoHideDuration={3000} onClose={() => setToast('')}>
        <Alert severity="info" onClose={() => setToast('')}>{toast}</Alert>
      </Snackbar>
    </DashboardLayout>
  );
}
